import React, { FC, useEffect, useRef, useState } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { motion } from "framer-motion";
import styles from "./styles";

interface Props {
  position?: "top" | "bottom";
  // eslint-disable-next-line react/no-unused-prop-types
  duration?: number;
  text: string | JSX.Element;
  visible?: boolean;
  id: number;
  // eslint-disable-next-line react/no-unused-prop-types
  onComplete?: () => void;
}

const Toast: FC<Props> = (props: Props) => {
  const { position, text, visible, id } = props;
  const toastRef = useRef();
  const theme = useTheme();
  const useStyles = createUseStyles(styles);
  const classes = useStyles({
    theme,
    ...props,
  });

  const [toastPosition, setToastPosition] = useState(0);
  useEffect(() => {
    if (toastRef.current && id) {
      setToastPosition(0);
    }
  }, [id]);

  return (
    <>
      {visible && (
        <motion.button
          initial={{ y: 100, x: "-50%" }}
          animate={{ y: toastPosition, x: "-50%" }}
          transition={{
            ease: toastPosition === 0 ? [0.28, 0.57, 0.2, 1] : "easeIn",
            duration: toastPosition === 0 ? 0.5 : 0.35,
            onComplete: () => {
              setTimeout(() => {
                setToastPosition(100);
              }, 1500);
            },
          }}
          type="button"
          ref={toastRef}
          className={`toast-test ${classes.toast} ${classes[position]}`}
          data-testid="toast-container"
        >
          <span className={classes.text}>{text}</span>
        </motion.button>
      )}
    </>
  );
};

Toast.defaultProps = {
  onComplete: () => {},
  position: "bottom",
  visible: false,
  duration: 5,
};

export default Toast;
try {
    // @ts-ignore
    Toast.displayName = "Toast";
    // @ts-ignore
    Toast.__docgenInfo = { "description": "", "displayName": "Toast", "props": { "position": { "defaultValue": { value: "bottom" }, "description": "", "name": "position", "required": false, "type": { "name": "\"bottom\" | \"top\"" } }, "duration": { "defaultValue": { value: 5 }, "description": "", "name": "duration", "required": false, "type": { "name": "number" } }, "text": { "defaultValue": null, "description": "", "name": "text", "required": true, "type": { "name": "string | Element" } }, "visible": { "defaultValue": { value: false }, "description": "", "name": "visible", "required": false, "type": { "name": "boolean" } }, "id": { "defaultValue": null, "description": "", "name": "id", "required": true, "type": { "name": "number" } }, "onComplete": { "defaultValue": { value: "() => {}" }, "description": "", "name": "onComplete", "required": false, "type": { "name": "() => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Toast/Toast.tsx#Toast"] = { docgenInfo: Toast.__docgenInfo, name: "Toast", path: "src/shared/components/Toast/Toast.tsx#Toast" };
}
catch (__react_docgen_typescript_loader_error) { }